import moment from 'moment';
import { KIND, kindOf, dayKey } from './calendarUtils';

const WEEKDAYS = ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'];

const DayCell = ({ day, inMonth, events, holiday, selected, onSelect }) => {
  const m = moment(day);
  const isToday = m.isSame(moment(), 'day');
  const isPast = m.isBefore(moment(), 'day');
  const weekend = m.isoWeekday() >= 6;
  const hasWedding = events.some(e => kindOf(e) === 'wedding');
  const shown = events.slice(0, 3);

  return (
    <button type="button" onClick={() => onSelect(day)} data-testid={`cal-day-${dayKey(day)}`}
      className={`group relative text-left min-h-[64px] sm:min-h-[104px] p-1.5 sm:p-2 border-b border-r border-border transition-colors
        ${inMonth ? '' : 'bg-muted/30'} ${weekend && inMonth ? 'bg-muted/20' : ''} ${hasWedding ? 'bg-rose-500/[0.06]' : ''}
        ${selected ? 'ring-2 ring-inset ring-primary z-10' : 'hover:bg-muted/40'}`}>
      <div className="flex items-center justify-between gap-1">
        <span className={`inline-flex items-center justify-center text-xs sm:text-sm font-semibold w-6 h-6 sm:w-7 sm:h-7 rounded-full
          ${isToday ? 'bg-primary text-primary-foreground' : ''} ${!inMonth || (isPast && !isToday) ? 'text-muted-foreground/60' : ''}
          ${holiday && !isToday ? (holiday.type === 'dini' ? 'text-emerald-600' : 'text-red-600') : ''}`}>
          {m.date()}
        </span>
        {events.length > 0 && <span className="sm:hidden text-[10px] font-bold text-muted-foreground">{events.length}</span>}
      </div>
      {holiday && <p className={`hidden sm:block text-[10px] leading-tight truncate mt-0.5 ${holiday.type === 'dini' ? 'text-emerald-600' : 'text-red-600'}`}>{holiday.name}</p>}

      {/* Mobil: renkli noktalar */}
      <div className="sm:hidden flex flex-wrap gap-0.5 mt-1">
        {events.slice(0, 4).map(e => <span key={e.id} className={`w-1.5 h-1.5 rounded-full ${KIND[kindOf(e)].dot}`} />)}
        {holiday && <span className={`w-1.5 h-1.5 rounded-full ${holiday.type === 'dini' ? 'bg-emerald-500' : 'bg-red-500'}`} />}
      </div>

      {/* Masaüstü: etkinlik etiketleri */}
      <div className="hidden sm:flex flex-col gap-0.5 mt-1">
        {shown.map(e => (
          <span key={e.id} className={`truncate text-[11px] leading-4 px-1.5 rounded border ${KIND[kindOf(e)].pill}`}>
            {(e.resource?.bride_name && `${e.resource.bride_name} & ${e.resource.groom_name}`) || e.title}
          </span>
        ))}
        {events.length > 3 && <span className="text-[10px] text-muted-foreground px-1">+{events.length - 3} daha</span>}
      </div>
    </button>
  );
};

export const MonthGrid = ({ date, byDay, holidayOf, selectedDay, onSelect }) => {
  const start = moment(date).startOf('month').startOf('isoWeek');
  const days = Array.from({ length: 42 }, (_, i) => start.clone().add(i, 'day').toDate());
  return (
    <div className="rounded-xl border border-border overflow-hidden bg-card" data-testid="cal-month-grid">
      <div className="grid grid-cols-7 bg-muted/50 border-b border-border">
        {WEEKDAYS.map((w, i) => (
          <div key={w} className={`py-2 text-center text-[11px] sm:text-xs font-semibold uppercase tracking-wider ${i >= 5 ? 'text-primary' : 'text-muted-foreground'}`}>{w}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 [&>*:nth-child(7n)]:border-r-0">
        {days.map(d => (
          <DayCell key={dayKey(d)} day={d} inMonth={moment(d).isSame(date, 'month')}
            events={byDay[dayKey(d)] || []} holiday={holidayOf(d)}
            selected={selectedDay && moment(d).isSame(selectedDay, 'day')} onSelect={onSelect} />
        ))}
      </div>
    </div>
  );
};
